import { walkPlan } from '@timelog/pm-shared';
import type { ProjectDocument } from '@timelog/pm-shared';

/**
 * The project frame the plan already implies: its earliest start and latest
 * end or target date. A project with an undated plan starts with no frame.
 */
export const planFrame = (
  document: Pick<ProjectDocument, 'plan'> | undefined,
): { startDate: string; endDate: string } => {
  let startDate = '';
  let endDate = '';
  if (!document) return { startDate, endDate };
  walkPlan(document.plan, (node) => {
    if (node.startDate && (startDate === '' || node.startDate < startDate)) {
      startDate = node.startDate;
    }
    for (const candidate of [node.endDate, node.targetDate]) {
      if (candidate && candidate > endDate) endDate = candidate;
    }
  });
  return { startDate, endDate };
};

/** ISO days compare as strings; an unset date never conflicts. */
export const isEndBeforeStart = (startDate: string, endDate: string): boolean =>
  startDate !== '' && endDate !== '' && endDate < startDate;
